"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stretchButtons = exports.toolbar_builder = exports.setDiagram = exports.addAllDropDownNode = exports.addSimpleLevelDropDown = void 0;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_multi_select_component_1 = require("react-multi-select-component");
const SankeyUtils_1 = require("./SankeyUtils");
const d3 = __importStar(require("d3"));
// import { FaNotesMedical } from 'react-icons/fa'
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
// Delete all local node variable : local_aggregation when we switch general aggregation 
const delete_local_aggregation = (data) => {
    Object.values(data.nodes).filter(n => n.local !== undefined).forEach(n => {
        if (n.local) {
            delete n.local.local_aggregation;
        }
    });
};
const addSimpleLevelDropDown = (t, data, set_data) => {
    const { levelTags } = data;
    if (Object.keys(levelTags).includes('Primaire')) {
        if (Object.keys(levelTags['Primaire'].tags).length < 2) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        const tmp = Object.entries(levelTags['Primaire'].tags).filter(tag => tag[1].selected);
        const selected = tmp.length > 0 ? tmp[0][0] : '';
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("td", null, react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, key: levelTags['Primaire'].group_name, value: selected, placeholder: 'all', onChange: (evt) => {
                        delete_local_aggregation(data);
                        handleSimpleDropdown(evt, levelTags['Primaire'], data, set_data);
                    } }, Object.entries(levelTags['Primaire'].tags).map(([tag_key, tag], i) => {
                    return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                }))))));
        // return (<><tr><th >{t('Banner.ndd_lst')}</th></tr>{allDD}</>)
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.addSimpleLevelDropDown = addSimpleLevelDropDown;
const addAllDropDownNode = (t, data, set_data, level) => {
    const color = 'black';
    const { nodeTags, levelTags } = data;
    let banner_grouptag = Object.entries(nodeTags).filter(([, tags_group]) => tags_group.banner !== 'none');
    if (level) {
        const nb_level_tag = Object.values(levelTags).filter(tags_group => (Object.keys(tags_group.tags).length > 0)).length;
        if (nb_level_tag > 1) {
            banner_grouptag = Object.entries(levelTags).filter(([, tags_group]) => tags_group.group_name !== 'Primaire' && Object.keys(tags_group.tags).length > 0);
        }
        else {
            banner_grouptag = Object.entries(levelTags).filter(([, tags_group]) => Object.keys(tags_group.tags).length > 1);
        }
    }
    const allDD = banner_grouptag.map(([, tags_group]) => {
        const tags_selected = Object.entries(data['nodeTags']).filter((k) => { return k[1] == tags_group; })[0];
        if (tags_group.banner == 'one') {
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: color } }, tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.5', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.5' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 }, react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, key: tags_group.group_name, placeholder: 'all', onChange: (evt) => {
                                handleSimpleDropdown(evt, tags_group, data, set_data);
                            } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                            return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                        })))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.5', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.5' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data.links).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = 'no_colormap';
                                        });
                                        data.colorMap = tags_selected[0];
                                        data['nodeTags'][tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
        else if (tags_group.banner === 'level' && Object.values(tags_group.tags).length > 0) {
            if (Object.keys(tags_group.tags).length < 1) {
                return react_1.default.createElement(react_1.default.Fragment, null);
            }
            const tmp = Object.entries(tags_group.tags).filter(tag => tag[1].selected);
            const selected = tmp.length > 0 ? tmp[0][0] : '';
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null, banner_grouptag.length > 1 ? react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: color } }, tags_group.group_name) : react_1.default.createElement(react_1.default.Fragment, null)),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.4', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.4' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, key: tags_group.group_name, value: selected, placeholder: 'all', onChange: (evt) => {
                                    delete_local_aggregation(data);
                                    handleSimpleDropdown(evt, tags_group, data, set_data);
                                } }, Object.entries(tags_group.tags).map(([tag_key, tag], i) => {
                                return (react_1.default.createElement("option", { key: i, value: tag_key }, tag.name));
                            })))),
                    tags_group.siblings !== undefined && tags_group.siblings.length > 0 ?
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.4', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.4' },
                                    t('Banner.ndd_chk'),
                                    " ") },
                                react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: tags_group.activated, onChange: evt => {
                                        tags_group.activated = evt.target.checked;
                                        tags_group.siblings.forEach(sibling => data.levelTags[sibling].activated = false);
                                        set_data(Object.assign({}, data));
                                    } }))) : react_1.default.createElement(react_1.default.Fragment, null))));
        }
        else if (tags_group.banner == 'multi') {
            const options = Object.entries(tags_group.tags).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            const selected = Object.entries(tags_group.tags).filter(d => d[1].selected).map((tag) => { return { 'label': tag[1].name, 'value': tag[1].name }; });
            return (react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, { style: { color: color } }, tags_group.group_name))),
                react_1.default.createElement(react_bootstrap_1.Row, null,
                    react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_lst.3', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_lst.3' },
                            t('Banner.ndd_lst'),
                            " ") },
                        react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                            react_1.default.createElement(react_multi_select_component_1.MultiSelect, { className: 'multidropdown_filter_node_link', style: { widthMax: '200px', color: 'black' }, valueRenderer: (selected) => {
                                    return selected.length ? selected.map(({ label }) => label + ', ') : 'Aucun tag sélectionné';
                                }, labelledBy: 'dropdown_node_filter', overrideStrings: {
                                    'selectAll': 'Tout sélectionner',
                                }, 
                                // hasSelectAll={false}
                                value: selected, options: options, onChange: (selected) => {
                                    handleMultiDropdown(selected, tags_group, data, set_data);
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 2 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'Banner.ndd_chk.3', placement: 'bottom', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'Banner.ndd_chk.3' },
                                t('Banner.ndd_chk'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormCheck, { inline: true, type: 'switch', checked: data.colorMap == tags_selected[0], onChange: evt => {
                                    Object.values(data.nodeTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.fluxTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.dataTags).forEach(tags_group => tags_group.show_legend = false);
                                    Object.values(data.nodes).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    Object.values(data.links).forEach(el => {
                                        el.colorParameter = 'local';
                                        el.colorTag = 'no_colormap';
                                    });
                                    data.colorMap = 'no_colormap';
                                    if (evt.target.checked) {
                                        Object.values(data.nodes).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = tags_selected[0];
                                        });
                                        Object.values(data.links).forEach(el => {
                                            el.colorParameter = 'groupTag';
                                            el.colorTag = 'no_colormap';
                                        });
                                        data.colorMap = tags_selected[0];
                                        data['nodeTags'][tags_selected[0]].show_legend = true;
                                    }
                                    set_data(Object.assign({}, data));
                                } }))))));
        }
    });
    // if (!level) {
    //   return (<><tr><th >{t('Banner.ndd_lst')}</th><th>{t('Banner.ndd_chk')}</th></tr>{allDD}</>)
    // } else {
    //   return (<><tr><th >{t('Banner.ndd_lst')}</th><th></th></tr>{allDD}</>)
    // }
    return (react_1.default.createElement(react_1.default.Fragment, null, allDD));
};
exports.addAllDropDownNode = addAllDropDownNode;
/**
 *
 *
 * @param {React.ChangeEvent<HTMLSelectElement>} evt
 * @param {TagsGroup} tags_group
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => void}
 */
const handleSimpleDropdown = (evt, tags_group, data, set_data) => {
    const val = evt.target.value;
    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = val === tag[0]);
    set_data(Object.assign({}, data));
};
/**
 *
 *
 * @param {[{ label: string, value: string }]} selected
 * @param {TagsGroup} tags_group
 * @param {SankeyData} data
 * @param {(data: SankeyData) => void} set_data
 * @returns {(void) => void}
 */
const handleMultiDropdown = (selected, tags_group, data, set_data) => {
    const tab_sel = selected.map((d) => {
        return d.value;
    });
    Object.entries(tags_group.tags).forEach(tag => tag[1].selected = tab_sel.includes(tag[1].name));
    // Permet d'eviter de désélectionner tous les dataTags ce qui créerait une erreur
    if (tab_sel.length == 0 && Object.values(data.dataTags).map(dt => dt.group_name).includes(tags_group.group_name)) {
        Object.entries(tags_group.tags)[0][1].selected = true;
    }
    set_data(Object.assign({}, data));
};
const setDiagram = (the_diagram, set_data, convert_data) => {
    //const the_diagram = evt.target.value as string
    const sous_filieres = window.sankey.sous_filieres;
    const new_data = JSON.parse(JSON.stringify(window.sankey[sous_filieres[the_diagram]]));
    //Object.assign(sankey_data, new_data)
    convert_data(new_data);
    // if (!is_split) {
    //   set_diagram(the_diagram)
    // }
    // new_data.fit_screen = true
    d3.select(' .opensankey #svg').on('.zoom', null);
    set_data(Object.assign({}, new_data));
};
exports.setDiagram = setDiagram;
const toolbar_builder = (t, data, set_data, mode_selection, user_scale, set_user_scale, filter, set_current_filter, detail_level, url_prefix, first_selected_node, set_first_selected_node, min_width_and_height, setDiagram, set_show_modal_welcome, set_never_see_again, convert_data, maximum_flux, set_maximum_flux, minimum_flux, set_minimum_flux) => {
    const level_filter = Object.entries(data.levelTags).length > 0;
    const [show_link_threshold, set_show_link_threshold] = react_1.useState(false);
    const target_link_threshold = react_1.useRef(null);
    const [show_detail_level, set_show_detail_level] = react_1.useState(false);
    const target_detail_level = react_1.useRef(null);
    /**
     * Change the mouse behavior
     *
     * @param {string} val
     */
    const setSelectionMode = (val) => {
        mode_selection.current = val;
        //- trigger update
        const tutu = filter;
        set_current_filter(filter + 1);
        set_current_filter(tutu);
        d3.selectAll(' .opensankey #svg #path-flux').remove();
        if (val == 's' && (Object.values(data.nodes).filter(d => d.name == 'node_tmp').length > 0 || Object.keys(first_selected_node).length != 0)) {
            data.nodes = Object.fromEntries(Object.entries(data.nodes).filter(n => n[1].name != 'node_tmp'));
            set_first_selected_node({});
        }
        // set_mode_selection(val)
    };
    let sous_filieres = undefined;
    if (window.sankey && window.sankey.sous_filieres) {
        sous_filieres = window.sankey.sous_filieres;
    }
    let is_split = false;
    const diagrams = {};
    if (sous_filieres) {
        is_split = Object.keys(sous_filieres)[0].includes('/');
        if (is_split) {
            Object.keys(sous_filieres).forEach(s => {
                const path = s.split('/');
                if (!(path[0] in diagrams)) {
                    diagrams[path[0]] = [path[1]];
                }
                else {
                    diagrams[path[0]].push(path[1]);
                }
            });
        }
        else {
            Object.keys(sous_filieres).forEach(s => diagrams[s] = [s]);
        }
    }
    const [diagram, set_diagram] = react_1.useState(Object.keys(diagrams).length > 0 ? Object.keys(diagrams)[0] : '');
    const [diagram2, set_diagram2] = react_1.useState(Object.keys(diagrams).length > 0 ? Object.values(diagrams)[0][0] : '');
    let max_link_value = 0;
    Object.values(data.links).forEach(link => {
        const new_max_link_value = SankeyUtils_1.findMaxLinkValue(max_link_value, link.value);
        max_link_value = new_max_link_value > max_link_value ? new_max_link_value : max_link_value;
    });
    max_link_value += 1;
    // Create the differents popover of tag filter  and link value filter
    //Popover element to handle filter on links, it contians :
    // - scale of link
    // - filter on link (if value of link is inferior to filter then the link is not displayed)
    // - filter on link label
    // - filter on null link (if link value is null (0), we can display it or not)
    const link_filter = react_1.default.createElement(react_bootstrap_1.Popover, { id: "popover-link-filter", style: { maxWidth: '100%', maxHeight: '600px', 'overflowY': 'auto' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.p_aff')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.Form, null,
                react_1.default.createElement("h5", null, t('Banner.p_aff_aff_links')),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.Echelle'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                        react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: user_scale, isInvalid: user_scale != data.user_scale, onChange: evt => {
                                set_user_scale(+evt.target.value);
                            }, onBlur: () => {
                                data.user_scale = user_scale;
                                set_data(Object.assign({}, data));
                            } }),
                        react_1.default.createElement(react_bootstrap_1.FormControl.Feedback, { type: 'invalid' }, t('MEP.onBlur')),
                        react_1.default.createElement(react_bootstrap_1.Form.Text, null,
                            "    (",
                            t('MEP.vp100'),
                            ")"))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.MaxFlux'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.MaxFlux', placement: 'top', delay: 500, rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.MaxFlux' },
                                t('MEP.tooltips.MaxFlux'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: maximum_flux == null ? undefined : maximum_flux, onChange: evt => {
                                    set_maximum_flux(+evt.target.value);
                                }, onBlur: () => {
                                    data.maximum_flux = isNaN(Number(maximum_flux)) ? undefined : maximum_flux;
                                    set_data(Object.assign({}, data));
                                } })))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('MEP.MinFlux'))),
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 5 },
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'MEP.tooltips.MinFlux', placement: 'top', delay: 500, rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'MEP.tooltips.MinFlux' },
                                t('MEP.tooltips.MinFlux'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { type: "text", value: minimum_flux == null ? undefined : minimum_flux, onChange: evt => {
                                    set_minimum_flux(+evt.target.value);
                                }, onBlur: () => {
                                    data.minimum_flux = isNaN(Number(minimum_flux)) ? undefined : minimum_flux;
                                    set_data(Object.assign({}, data));
                                } })))),
                react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
                react_1.default.createElement("h5", null, t('Banner.p_aff_filtre_links')),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Banner.filtre'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: max_link_value, value: filter, onChange: evt => set_current_filter(Number(evt.target.value)) })),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', type: 'number', min: 0, max: filter, value: filter, onChange: (evt) => {
                                let tmp = +evt.target.value;
                                if (tmp > max_link_value) {
                                    tmp = max_link_value;
                                }
                                set_current_filter(tmp);
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Banner.fl'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.Form.Range, { min: "0", max: max_link_value, value: data.display_style.filter_label, onChange: evt => {
                                data.display_style.filter_label = +evt.target.value;
                                set_data(Object.assign({}, data));
                            } })),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormControl, { size: 'sm', type: 'number', min: 0, max: max_link_value, value: data.display_style.filter_label, onChange: (evt) => {
                                let tmp = +evt.target.value;
                                if (tmp > max_link_value) {
                                    tmp = max_link_value;
                                }
                                data.display_style.filter_label = tmp;
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null,
                            t('Banner.fn'),
                            ":")),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.FormCheck, { type: 'checkbox', label: t('Banner.visible'), onChange: evt => {
                                data.display_style.null_flux = evt.target.checked;
                                set_data(Object.assign({}, data));
                            } }))),
                react_1.default.createElement("hr", { style: { borderStyle: 'none', margin: '10px', color: 'grey', backgroundColor: 'grey', height: 2 } }),
                react_1.default.createElement("h5", null, t('Banner.p_aff_aff_node')),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.apparence.TML'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.6', placement: 'top', delay: 500, rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.6' },
                                t('Noeud.apparence.tooltips.TML'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, step: 1, type: 'number', value: data.node_width, onChange: evt => {
                                    const val = evt.target.value;
                                    let value = 40;
                                    if (!isNaN(+val)) {
                                        value = Math.abs(Math.round(+val));
                                    }
                                    data.node_width = value;
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Col, null, "px")),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
                    react_1.default.createElement(react_bootstrap_1.Col, { xs: 4 },
                        react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.apparence.TMH'))),
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'noeud.apparence.tooltips.7', placement: 'top', delay: 500, rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'noeud.apparence.tooltips.7' },
                                t('Noeud.apparence.tooltips.TMH'),
                                " ") },
                            react_1.default.createElement(react_bootstrap_1.FormControl, { min: 0, max: 100, type: 'number', value: data.node_height, onChange: evt => {
                                    const val = evt.target.value;
                                    let value = 40;
                                    if (!isNaN(+val)) {
                                        value = Math.abs(Math.round(+val));
                                    }
                                    data.node_height = value;
                                    set_data(Object.assign({}, data));
                                } }))),
                    react_1.default.createElement(react_bootstrap_1.Col, null, "px")))));
    let diagrams_element = react_1.default.createElement(react_1.default.Fragment, { key: '1' });
    if (window.SankeyToolsStatic && sous_filieres && !is_split) {
        diagrams_element =
            react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '1', as: react_bootstrap_1.Col, style: { marginLeft: '10px' }, lg: "auto" },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, onChange: evt => {
                        set_diagram(evt.target.value);
                        setDiagram(evt.target.value, set_data, convert_data);
                    }, value: diagram }, Object.keys(sous_filieres).map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))));
    }
    if (window.SankeyToolsStatic && sous_filieres && is_split) {
        diagrams_element =
            react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '2', as: react_bootstrap_1.Col, style: { marginLeft: '10px' }, lg: "auto" },
                react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, onChange: (evt) => {
                        set_diagram(evt.target.value);
                        const diagram_path = evt.target.value + '/' + diagrams[evt.target.value][0];
                        setDiagram(diagram_path, set_data, convert_data);
                    }, value: diagram }, Object.keys(diagrams).map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))),
                is_split ?
                    (react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, onChange: (evt) => {
                            set_diagram2(evt.target.value);
                            const diagram_path = diagram + '/' + evt.target.value;
                            setDiagram(diagram_path, set_data, convert_data);
                        }, value: diagram2 }, diagrams[diagram] ? (Object.values(diagrams[diagram]).map((name, i) => react_1.default.createElement("option", { key: i, value: name }, name))) : (react_1.default.createElement(react_1.default.Fragment, null)))) : (react_1.default.createElement(react_1.default.Fragment, null)));
    }
    const excel_element = window.sankey && window.sankey.excel ? (react_1.default.createElement(react_bootstrap_1.Form.Group, { key: '3', as: react_bootstrap_1.Col, lg: "auto", style: { marginRight: '10px' } },
        react_1.default.createElement(react_bootstrap_1.Button, { variant: 'link', href: window.sankey.excel }, t('Banner.tl')))) : (react_1.default.createElement(react_1.default.Fragment, { key: '3' }));
    const struc_data_reconciled = react_1.default.createElement(react_bootstrap_1.Popover, { id: 'popover-details-level', style: { maxWidth: '100%' } },
        react_1.default.createElement(react_bootstrap_1.Popover.Header, { as: "h3" }, t('Banner.sdr')),
        react_1.default.createElement(react_bootstrap_1.Popover.Body, null,
            react_1.default.createElement(react_bootstrap_1.FormGroup, { as: react_bootstrap_1.Row },
                react_1.default.createElement(react_bootstrap_1.Col, { xs: 10 },
                    react_1.default.createElement(react_bootstrap_1.Form.Select, { style: { width: '200px', color: 'black' }, placeholder: 'all', value: data.show_structure, onChange: (evt) => {
                            data.show_structure = evt.target.value;
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement("option", { key: 'structure', value: 'structure' }, "Structure"),
                        react_1.default.createElement("option", { key: 'data', value: 'data' }, "Donn\u00E9es collect\u00E9es"),
                        react_1.default.createElement("option", { key: 'reconciled', value: 'reconciled' }, "Donn\u00E9es r\u00E9concili\u00E9es"),
                        react_1.default.createElement("option", { key: 'free_interval', value: 'free_interval' }, "Donn\u00E9es r\u00E9concili\u00E9es+flux ind\u00E9termin\u00E9es (intervalles)"),
                        react_1.default.createElement("option", { key: 'free_value', value: 'free_value' }, "Donn\u00E9es r\u00E9concili\u00E9es+flux ind\u00E9termin\u00E9es (valeurs)"))))));
    const ui = {};
    if ((Object.keys(diagrams).length > 0)) {
        ui['diagramme'] = diagrams_element;
    }
    if (window.sankey && window.sankey.excel) {
        ui['excel'] = (excel_element);
    }
    let mouse_mode_edition = react_1.default.createElement(react_1.default.Fragment, null);
    // Add button for the edition of the sankey
    if (!window.SankeyToolsStatic) {
        mouse_mode_edition = react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-selection', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-selection' },
                    t('Banner.tooltipSelection'),
                    " ") },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: (!(mode_selection.current == 's')) ? 'outline-info' : 'info', onClick: () => { setSelectionMode('s'); } },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowPointer })))),
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-liaison', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-liason' },
                    t('Banner.tooltipLiason'),
                    " ") },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: (!(mode_selection.current == 'ln')) ? 'outline-secondary' : 'secondary', onClick: () => { setSelectionMode('ln'); } },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faShareNodes })))));
    }
    ui['toolbar'] = (react_1.default.createElement(react_1.default.Fragment, null,
        mouse_mode_edition,
        (level_filter) ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-nodes-level', placement: 'left', rootClose: true, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-nodes-level' },
                    t('Banner.hlp_1_txt_2'),
                    " ") },
                react_1.default.createElement(react_bootstrap_1.Button, { ref: target_detail_level, variant: 'outline-warning', id: 'button-details-level', onClick: () => { set_show_detail_level(!show_detail_level); } },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faFolderTree })))),
            react_1.default.createElement(react_bootstrap_1.Overlay, { key: 'popover-nodes-level', placement: 'left', target: target_detail_level, rootClose: true, show: show_detail_level, onHide: () => { set_show_detail_level(false); } }, detail_level))
            :
                react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-link-filter2', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-link-filter2' },
                t('Banner.hlp_1_txt_8'),
                " ") },
            react_1.default.createElement(react_bootstrap_1.Button, { ref: target_link_threshold, variant: 'outline-danger', id: 'button-filter-link', onClick: () => {
                    set_show_link_threshold(!show_link_threshold);
                } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faSliders })))),
        react_1.default.createElement(react_bootstrap_1.Overlay, { key: 'popover-link-filter', placement: 'left', target: target_link_threshold, rootClose: true, show: show_link_threshold, onHide: () => { set_show_link_threshold(false); } }, link_filter),
        exports.stretchButtons(data, min_width_and_height, t),
        url_prefix !== '' ?
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-structur', placement: 'left', trigger: 'click', rootClose: true, overlay: struc_data_reconciled },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-success' },
                    react_1.default.createElement(react_bootstrap_1.Col, null,
                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDiagramProject }))))
            :
                react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-structur', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-structur' },
                        t('Banner.tooltipStructure'),
                        " ") },
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-success', onClick: () => {
                            data.show_structure = data.show_structure == 'reconciled' ? 'structure' : 'reconciled';
                            //data.show_data = false
                            set_data(Object.assign({}, data));
                        } },
                        react_1.default.createElement(react_bootstrap_1.Col, null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCodeBranch })))),
        window.SankeyToolsStatic ? react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-help', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-help' }, t('Banner.tooltipHelp')) },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'info', onClick: () => { set_never_see_again(false); localStorage.removeItem('dontSeeAggainWelcome'), set_show_modal_welcome(true); } },
                react_1.default.createElement(react_bootstrap_1.Col, null, " ? "))) : react_1.default.createElement(react_1.default.Fragment, null)));
    return ui;
};
exports.toolbar_builder = toolbar_builder;
const stretchButtons = (data, min_width_and_height, t) => {
    return react_1.default.createElement(react_1.default.Fragment, null,
        " ",
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-adjust-h', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-adjust-h' },
                t('Banner.tooltipAdjust'),
                " ") },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-dark', onClick: () => { SankeyUtils_1.adjust_sankey_zone(data, min_width_and_height); } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowsLeftRight })))),
        react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { key: 'tooltip-adjust-v', placement: 'left', delay: 500, overlay: react_1.default.createElement(react_bootstrap_1.Tooltip, { id: 'tooltip-adjust-v' },
                t('Banner.tooltipAdjust'),
                " ") },
            react_1.default.createElement(react_bootstrap_1.Button, { variant: 'outline-dark', onClick: () => { SankeyUtils_1.adjust_sankey_zone(data, min_width_and_height, false, true); } },
                react_1.default.createElement(react_bootstrap_1.Col, null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faArrowsUpDown })))));
};
exports.stretchButtons = stretchButtons;
